import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=ffc1047e&scoped=true"
import script from "./main-header.vue?vue&type=script&lang=js"
export * from "./main-header.vue?vue&type=script&lang=js"
import style0 from "./main-header.vue?vue&type=style&index=0&id=ffc1047e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc1047e",
  null
  
)

export default component.exports